// import JournalReport from "./Body/Reports/JournalReport/JournalReport";
// import AddSalesReturn from "./Body/Sales/AddSalesReturn";
import { routes } from "./routes";
// import Dashboard from "./Body/Dashboard/Dashboard";
// import Products from "./Body/Products/Products";
// import Customers from './Body/Customers/Customers'
// import Suppliers from './Body/Suppliers/Suppliers'
// import AddProduct from "./Body/Products/AddProduct.js";
// import AddCustomer from "./Body/Customers/AddCustomer.js";
// import AddSupplier from "./Body/Suppliers/AddSupplier.js";
// import Brands from "./Body/Brands/Brands.js"
// import AddBrand from "./Body/Brands/AddBrand.js"
// import Categories from "./Body/Categories/Categories.js"
// import AddCategory from "./Body/Categories/AddCategory"
// import Actions from "./Body/Actions/Actions"
// import AddPurchase from "./Body/Purchase/AddPurchase.js";
// import Purchase from "./Body/Purchase/Purchase.js";
// import Sales from "./Body/Sales/Sales.js";
// import AddSale from "./Body/Sales/AddSale";
// import Backup from "./Body/Backup/Backup.js";
// import Users from "./Body/Users/Users.js";
// import AddUser from "./Body/Users/AddUser.js";
// import MyAccount from "./Body/MyAccount/MyAccount";

import loadable from "@loadable/component";
const Dashboard = loadable(
  () => import(/* webpackChunkName: "dashboard" */ "./Body/Dashboard/Dashboard")
);
const Products = loadable(
  () => import(/* webpackChunkName: "products" */ "./Body/Products/Products")
);
const Customers = loadable(
  () => import(/* webpackChunkName: "customers" */ "./Body/Customers/Customers")
);
const Suppliers = loadable(
  () => import(/* webpackChunkName: "suppliers" */ "./Body/Suppliers/Suppliers")
);
const AddProduct = loadable(
  () =>
    import(/* webpackChunkName: "addProduct" */ "./Body/Products/AddProduct")
);
const ProductHistory = loadable(
  () =>
    import(
      /* webpackChunkName: "productHistory" */ "./Body/Products/ProductHistory"
    )
);
const AddCustomer = loadable(
  () =>
    import(/* webpackChunkName: "addCustomer" */ "./Body/Customers/AddCustomer")
);
const CustomerTransaction = loadable(
  () =>
    import(
      /* webpackChunkName: "customer trasactions" */ "./Body/Customers/Transactions"
    )
);
const AddSupplier = loadable(
  () =>
    import(/* webpackChunkName: "addSupplier" */ "./Body/Suppliers/AddSupplier")
);
const SupplierTransaction = loadable(
  () =>
    import(
      /* webpackChunkName: "supplier trasactions" */ "./Body/Suppliers/Transactions"
    )
);
const Brands = loadable(
  () => import(/* webpackChunkName: "brands" */ "./Body/Brands/Brands")
);
const AddBrand = loadable(
  () => import(/* webpackChunkName: "addBrands" */ "./Body/Brands/AddBrand")
);
const Categories = loadable(
  () =>
    import(/* webpackChunkName: "categories" */ "./Body/Categories/Categories")
);
const AddCategory = loadable(
  () =>
    import(
      /* webpackChunkName: "addCategories" */ "./Body/Categories/AddCategory"
    )
);
const Actions = loadable(
  () => import(/* webpackChunkName: "actions" */ "./Body/Actions/Actions")
);
const AddPurchase = loadable(
  () =>
    import(/* webpackChunkName: "addPurchase" */ "./Body/Purchase/AddPurchase")
);

const AddPurchaseReturn = loadable(
  () =>
    import(
      /* webpackChunkName: "addPurchaseReturn" */ "./Body/Purchase/AddPurchaseReturn"
    )
);

// const AddPurchaseReturn = loadable(
//   () => import("./Body/Purchase/AddPurchaseReturn")
// );
const Purchase = loadable(
  () => import(/* webpackChunkName: "purchase" */ "./Body/Purchase/Purchases")
);
const PurchaseReport = loadable(
  () =>
    import(
      /* webpackChunkName: "purchasereport" */ "./Body/Purchase/PurchaseReport"
    )
);
const PurchaseReturnReport = loadable(
  () =>
    import(
      /* webpackChunkName: "purchasereturnreport" */ "./Body/Purchase/PurchaseReturnData"
    )
);
const Sales = loadable(
  () => import(/* webpackChunkName: "sales" */ "./Body/Sales/Sales")
);
const SalesReport = loadable(
  () => import(/* webpackChunkName: "salesreport" */ "./Body/Sales/SalesReport")
);
const SalesReturnReport = loadable(
  () =>
    import(
      /* webpackChunkName: "salesreturnreport" */ "./Body/Sales/SalesReturnData"
    )
);
const AddSale = loadable(
  () => import(/* webpackChunkName: "addSale" */ "./Body/Sales/AddSale")
);
const Backup = loadable(
  () => import(/* webpackChunkName: "backup" */ "./Body/Backup/Backup")
);
const Users = loadable(
  () => import(/* webpackChunkName: "users" */ "./Body/Users/Users")
);
const AddUser = loadable(
  () => import(/* webpackChunkName: "addUser" */ "./Body/Users/AddUser")
);
const MyAccount = loadable(
  () => import(/* webpackChunkName: "myAccount" */ "./Body/MyAccount/MyAccount")
);
const Settings = loadable(
  () => import(/* webpackChunkName: "settings" */ "./Body/Settings/Settings")
);
const BusinessSetting = loadable(
  () =>
    import(
      /* webpackChunkName: "businessSetting" */ "./Body/Business Setting/BusinessSetting"
    )
);
const MaterializedView = loadable(
  () =>
    import(
      /* webpackChunkName: "materializedView" */ "./Body/Audits/MaterializedView"
    )
);
const Help = loadable(
  () => import(/* webpackChunkName: "help" */ "./Body/Help/Issues")
);
const AddIssue = loadable(
  () => import(/* webpackChunkName: "addIssue" */ "./Body/Help/AddIssue")
);
const ChartOfAccounts = loadable(
  () =>
    import(
      /* webpackChunkName: "chartOfAccounts" */ "./Body/Reports/ChartOfAccount/ChartOfAccounts"
    )
);

const ChartOfAccountsType = loadable(
  () =>
    import(
      /* webpackChunkName: "chartOfAccountsType" */ "./Body/Reports/ChartOfAccountsType/ChartOfAccountsType"
    )
);

const EachChartOfAccount = loadable(
  () =>
    import(
      /* webpackChunkName: "eachChartOfAccount" */ "./Body/Reports/ChartOfAccount/EachChartofAccount"
    )
);

const ProfitLossAccount = loadable(
  () =>
    import(
      /* webpackChunkName: "profitLossAccount" */ "./Body/Reports/ProfitLossAccount/ProfitLossAccount"
    )
);

const Banks = loadable(
  () => import(/* webpackChunkName: "banks" */ "./Body/Banks/Banks")
);
const AddBank = loadable(
  () => import(/* webpackChunkName: "addBank" */ "./Body/Banks/AddBank")
);

const BalanceSheet = loadable(
  () =>
    import(
      /* webpackChunkName: "balanceSheet" */ "./Body/Reports/BalanceSheet/BalanceSheet"
    )
);

const JournalReport = loadable(
  () =>
    import(
      /* webpackChunkName: "pageNotFound" */ "./Body/Reports/JournalReport/JournalReport"
    )
);

const AddSalesReturn = loadable(
  () =>
    import(/* webpackChunkName: "pageNotFound" */ "./Body/Sales/AddSalesReturn")
);

const PageNotFound = loadable(
  () => import(/* webpackChunkName: "pageNotFound" */ "./PageNotFound")
);

export const pageRoutesAuth = [
  {
    title: "Dashboard",
    path: routes.index,
    component: () => <Dashboard />,
    permission: ["users"],
  },

  {
    title: "Products",
    path: routes.products,
    component: () => <Products />,
    permission: ["purchases", "sells", "stock"],
  },

  {
    title: "Add Product",
    path: routes.addProduct,
    component: () => <AddProduct />,
    permission: ["purchases", "sells", "stock"],
  },
  {
    title: "Product History",
    path: routes.productHistory,
    component: () => <ProductHistory />,
    permission: ["purchases", "sells", "stock"],
  },

  {
    title: "Customers",
    path: routes.customers,
    component: () => <Customers />,
    permission: ["sells", "customers"],
  },
  {
    title: "Customer Transactions",
    path: routes.customerTransactions,
    component: () => <CustomerTransaction />,
    permission: ["sells", "customers"],
  },

  {
    title: "Add Customer",
    path: routes.addCustomer,
    component: () => <AddCustomer />,
    permission: ["sells", "customers"],
  },

  {
    title: "Suppliers",
    path: routes.suppliers,
    component: () => <Suppliers />,
    permission: ["purchases", "suppliers"],
  },
  {
    title: "Supplier Transactions",
    path: routes.supplierTransactions,
    component: () => <SupplierTransaction />,
    permission: ["purchases", "suppliers"],
  },

  {
    title: "Add Supplier",
    path: routes.addSupplier,
    component: () => <AddSupplier />,
    permission: ["purchases", "suppliers"],
  },

  {
    title: "Brands",
    path: routes.brands,
    component: () => <Brands />,
    permission: ["purchases", "sells", "stock", "brands"],
  },

  {
    title: "Add Brand",
    path: routes.addBrand,
    component: () => <AddBrand />,
    permission: ["purchases", "sells", "stock", "brands"],
  },

  {
    title: "Categories",
    path: routes.categories,
    component: () => <Categories />,
    permission: ["purchases", "sells", "stock", "category"],
  },

  {
    title: "Add Category",
    path: routes.addCategory,
    component: () => <AddCategory />,
    permission: ["purchases", "sells", "stock", "category"],
  },

  {
    title: "Actions",
    path: routes.actions,
    component: () => <Actions />,
    permission: ["users"],
  },

  {
    title: "Purchases",
    path: routes.purchases,
    component: () => <Purchase />,
    permission: ["purchases"],
  },

  {
    title: "Add Purchase",
    path: routes.addPurchase,
    component: () => <AddPurchase />,
    permission: ["purchases"],
  },
  {
    title: "Add Purchase Return",
    path: routes.addPurchaseReturn,
    component: () => <AddPurchaseReturn />,
    permission: ["purchases"],
  },

  {
    title: "Purchase Report",
    path: routes.purchaseReport,
    component: () => <PurchaseReport />,
    permission: ["purchases"],
  },

  {
    title: "Purchase Return Report",
    path: routes.purchaseReturnReport,
    component: () => <PurchaseReturnReport />,
    permission: ["purchases"],
  },

  {
    title: "Sales",
    path: routes.sales,
    component: () => <Sales />,
    permission: ["sells"],
  },

  {
    title: "Add Sale",
    path: routes.addSale,
    component: () => <AddSale />,
    permission: ["sells"],
  },
  {
    title: "Add Sale Return",
    path: routes.addSaleReturn,
    component: () => <AddSalesReturn />,
    permission: ["sells"],
  },
  {
    title: "Sales Report",
    path: routes.salesReport,
    component: () => <SalesReport />,
    permission: ["sells"],
  },

  {
    title: "Sales Return Report",
    path: routes.salesReturnReport,
    component: () => <SalesReturnReport />,
    permission: ["sells"],
  },

  {
    title: "Users",
    path: routes.users,
    component: () => <Users />,
    permission: ["users"],
  },

  {
    title: "Add User",
    path: routes.addUser,
    component: () => <AddUser />,
    permission: ["users"],
  },

  {
    title: "Backup",
    path: routes.backup,
    component: () => <Backup />,
    permission: ["users"],
  },

  {
    title: "Account",
    path: routes.account,
    component: () => <MyAccount />,
    permission: ["all"],
  },

  {
    title: "Banks",
    path: routes.banks,
    component: () => <Banks />,
    permission: ["all"],
  },

  {
    title: "Add Bank",
    path: routes.addBank,
    component: () => <AddBank />,
    permission: ["all"],
  },

  {
    title: "Settings",
    path: routes.settings,
    component: () => <Settings />,
    permission: ["all"],
  },

  {
    title: "Business Settings",
    path: routes.businessSetting,
    component: () => <BusinessSetting />,
    permission: ["all"],
  },

  {
    title: "Materialized View",
    path: routes.materializedView,
    component: () => <MaterializedView />,
    permission: ["all"],
  },
  {
    title: "Journal Report",
    path: routes.journalReport,
    component: () => <JournalReport />,
    permission: ["all"],
  },

  {
    title: "Chart of Accounts",
    path: routes.chartOfAccounts,
    component: () => <ChartOfAccounts />,
    permission: ["all"],
  },
  {
    title: "Each Chart of Account",
    path: routes.eachChartOfAccount,
    component: () => <EachChartOfAccount />,
    permission: ["all"],
  },
  {
    title: "Chart of Accounts Type",
    path: routes.chartOfAccountsType,
    component: () => <ChartOfAccountsType />,
    permission: ["all"],
  },

  {
    title: "Balance Sheet",
    path: routes.balanceSheet,
    component: () => <BalanceSheet />,
    permission: ["all"],
  },

  {
    title: "Profit and Loss Account",
    path: routes.profitLossAccount,
    component: () => <ProfitLossAccount />,
    permission: ["all"],
  },
  {
    title: "Issue List",
    path: routes.help,
    component: () => <Help />,
    permission: ["all"],
  },

  {
    title: "Add Issue",
    path: routes.addissue,
    component: () => <AddIssue />,
    permission: ["all"],
  },
  {
    title: "",
    path: routes["404"],
    component: () => <PageNotFound />,
    permission: ["all"],
  },
];
